module.exports = __webpack_public_path__ + "assets/3fc288ae1a4345491e84cd49f10c8ea2.png";